import Joi from 'joi';

export const DownloadSchema = Joi.object({
  title: Joi.string().required(),
  pined: Joi.string().required(),
  file: Joi.string().required(),
});
